import React, {useContext, useEffect, useState} from 'react';
import './Task.css'
import {Context} from "../../index";
import {useNavigate, useParams} from "react-router-dom";
import {fetchUsers} from "../../http/UserAPI";
import {fetchOneTask, updateTask} from "../../http/TaskAPI";
import {observer} from "mobx-react-lite";
import {fetchStatement, updateStatement} from "../../http/StatementAPI";
import Comments from "../Comments/Comments";
import FilesComponent from "../FilesComponent/FilesComponent";
import StatementComponent from "../StatementComponent/StatementComponent";
import pinning_img from "../../accets/img/pinning_img.png"
import ModalTaskToMessage from "../Modal/ModalTaskToMessage";
import send from "../../accets/img/send.png";
import {fetchFiles} from "../../http/FileAPI";
import {FriendContext} from "../../App";
import {createTracking, deleteTracking} from "../../http/TrackingAPI";

const Task = () => {

    const [show, setShow] = useState(true)
    const [stText, setStText] = useState('')
    const [showPriority, setShowPriority] = useState(false)
    const [showTaskToMsg, setShowTaskToMsg] = useState(false)
    const [showExecutor, setShowExecutor] = useState(false)
    const [allUsers, setAllUsers] = useState([])
    const [priorityTask, setPriorityTask] = useState(0)
    const [executor, setExecutor] = useState(0)


    const {fileStore, priorityStore, userStore, statementStore, taskStore, trackingStore} = useContext(Context)
    const {oneTask, setOneTask} = useContext(FriendContext)

    let {id} = useParams()

    const navigate = useNavigate()

    useEffect(() => {
        fetchUsers().then(data => setAllUsers(data))
        fetchOneTask(id).then(data => setOneTask(data))
        fetchFiles().then(data => fileStore.setFile(data))
        fetchStatement().then(data => statementStore.setStatement(data))
    }, [id])

    useEffect(() => {
        fetchOneTask(id).then(data => setOneTask(data))
    }, [id, oneTask])

    const UserTask = allUsers.filter(obj => obj.id === oneTask.userId)
    const StatementTask = statementStore.statement.filter(obj => obj.taskId === oneTask.id)
    const ExecutorTask = allUsers.filter(obj => obj.id === oneTask.executor)
    const TaskPriority = priorityStore.priority.filter(obj => obj.id === oneTask.priority)
    const FileTask = fileStore.file.filter(obj => obj.taskId === oneTask.id)
    const TrackingToTask = trackingStore.tracking.filter(obj => obj.taskId === oneTask.id && obj.userId === userStore.user.id)


    const UserStatement = StatementTask.map((info) => {
        const withUserId = allUsers.filter(user => user['id'] === info['userId'])
        const user = withUserId.reduce((acc, current) => {
            acc.push(current)
            return acc
        }, [])
        return {...info, user: user}
    })

    const statementJob = {
        id: StatementTask.map(i => i.id),
        text: stText,
        userId: userStore.user.id,
        agreedId: null,
        status: "JOB",
        taskId: StatementTask.map(i => i.taskId)
    }
    const statementYes = {
        id: StatementTask.map(i => i.id),
        userId: StatementTask.map(obj => obj.userId),
        agreedId: userStore.user.id,
        status: "YES",
        taskId: StatementTask.map(obj => obj.taskId)
    }
    const statementNo = {
        id: StatementTask.map(i => i.id),
        userId: StatementTask.map(obj => obj.userId),
        agreedId: userStore.user.id,
        status: "NO",
        taskId: StatementTask.map(obj => obj.taskId)
    }

    const TaskClose = {id: oneTask.id, status: "CLOSE"}
    const TaskNew = {id: oneTask.id, status: "NEW"}
    const TaskStatement = {id: oneTask.id, status: "STATEMENT"}
    const UpdatePriority = {id: oneTask.id, priority: priorityTask}
    const UpdateExecutor = {id: oneTask.id, executor: executor}
    const UpdatePinningEneb = {id: oneTask.id, pinning: true}
    const UpdatePinningDis = {id: oneTask.id, pinning: false}
    const TrackEnDis = {taskId: oneTask.id, userId: userStore.user.id}

    const btnYes = (statementYes) => {
        updateStatement(statementYes)
        fetchStatement().then(data => statementStore.setStatement(data))
    }

    const btnNo = (statementNo) => {
        updateStatement(statementNo)
        fetchStatement().then(data => statementStore.setStatement(data))
    }

    const btnJob = (statementJob) => {
        updateStatement(statementJob)
        updateTask(TaskStatement)
        fetchStatement().then(data => statementStore.setStatement(data))
    }


    const TaskCloseBtn = (TaskClose) => {
        updateTask(TaskClose)
        navigate('/job/task')
    }

    const TaskNewBtn = (TaskNew) => {
        updateTask(TaskNew)
        navigate('/job/task')
    }

    const UpdatePriorityBtn = (UpdatePriority) => {
        taskStore.updTask(UpdatePriority)
        setShowPriority(false)
    }

    const UpdateExecutorBtn = (UpdateExecutor) => {
        taskStore.updTask(UpdateExecutor)
        setShowExecutor(false)
    }

    const UpdatePinningEnBtn = (UpdatePinningEneb) => {
        updateTask(UpdatePinningEneb)
    }

    const UpdatePinningDisBtn = (UpdatePinningDis) => {
        updateTask(UpdatePinningDis)
    }

    const TrackingEnAndDis = () => {
        if (TrackingToTask.length) {
            deleteTracking(TrackingToTask[0].id)
        }
        if (!TrackingToTask.length) {
            createTracking(TrackEnDis)
        }
    }

    return (
        <div className="ml">
            <div className="task__name__block">
                <div className="title__task">
                    Задача № {oneTask.id} от {new Date(oneTask.createdAt).toLocaleString()} создал(а):
                    {UserTask.map(i =>
                        <span key={i.id}> {i.firstName} {i.secondName}</span>
                    )}
                </div>
                <div className="btn__block">
                    {oneTask.status !== "CLOSE" ?
                        <button onClick={() => TaskCloseBtn(TaskClose)}>Выполнить</button>
                        :
                        <button onClick={() => TaskNewBtn(TaskNew)}>Открыть снова</button>
                    }
                    <button onClick={() => navigate('/job/task')}>Закрыть</button>
                </div>
            </div>

            <div className="input__block">
                <div className="name__input">Наименование задачи</div>
                <div className="one__task__name__block">
                    {!oneTask.name
                        ?
                        <div className="one__task__name__block__text">Без наименования</div>
                        :
                        <div className="one__task__name__block__text">{oneTask.name}</div>
                    }

                </div>
            </div>

            <div className="input__block input__block__info">
                <div className="name__input">Подробности задачи</div>
                <div className="one__task__name__block">
                    {!oneTask.description
                        ?
                        <div className="one__task__name__block__text">Без подробностей</div>
                        :
                        <div className="one__task__name__block__text">{oneTask.description}</div>
                    }

                </div>
            </div>

            {oneTask.priority === 0
                ? <div className="priority__block">
                    <div className="name__cat">Приоритет</div>
                    <select onChange={e => setPriorityTask(e.target.value)} value={priorityTask}
                            className="select__css">
                        <option>Выбор...</option>
                        {priorityStore.priority.map(priority =>
                            <option
                                onClick={() => setPriorityTask(priority)}
                                key={priority.id}
                                value={priority.id}
                            >
                                {priority.name}
                            </option>
                        )}
                    </select>
                    {priorityTask !== 0
                        ?
                        <div className="up__btn__show" onClick={() => UpdatePriorityBtn(UpdatePriority)}>
                            Применить
                        </div>
                        : null
                    }
                    <h4>Выберите важность данной задачи, если есть такая потребность </h4>
                </div>
                :
                <div className="priority__block">
                    <div className="name__cat">Приоритет</div>
                    <div className="one__task__priority__block">
                        {TaskPriority.map(i =>
                            <div key={i.id} className="one__task__priority__block__text">{i.name}</div>
                        )}

                    </div>
                    <div className="update__priority__block">
                        <div style={{display: showPriority ? "none" : "block"}} onClick={() => setShowPriority(true)}
                             className="up__btn__show">
                            Сменить приоритет
                        </div>
                        <div style={{display: !showPriority ? "none" : "flex"}} className="up__pr">
                            <select onChange={e => setPriorityTask(e.target.value)} value={priorityTask}
                                    className="select__css">
                                <option>Выбор...</option>
                                {priorityStore.priority.map(priority =>
                                    <option
                                        onClick={() => setPriorityTask(priority)}
                                        key={priority.id}
                                        value={priority.id}
                                    >
                                        {priority.name}
                                    </option>
                                )}
                            </select>
                            <div className="up__btn__show" onClick={() => UpdatePriorityBtn(UpdatePriority)}>
                                Применить
                            </div>
                            <div className="up__btn__show" onClick={() => setShowPriority(false)}>
                                Отмена
                            </div>

                        </div>
                    </div>
                    {taskStore.isLoadingPr &&
                        <span className="loader"></span>
                    }
                </div>
            }


            {oneTask.executor === 0
                ?
                <div className="priority__block">
                    <div className="name__cat">Исполнитель</div>
                    <select onChange={e => setExecutor(e.target.value)} value={executor} className="select__css">
                        <option>Выбор...</option>
                        {allUsers.map(users =>
                            <option
                                onClick={() => setExecutor(users)}
                                key={users.id}
                                value={users.id}
                            >
                                {users.firstName} {users.secondName}
                            </option>
                        )}
                    </select>
                    {executor !== 0
                        ?
                        <div className="up__btn__show" onClick={() => UpdateExecutorBtn(UpdateExecutor)}>
                            Применить
                        </div>
                        : null
                    }
                    <h4>Выберите исполнителя для задачи</h4>
                </div>
                :
                <div className="priority__block">
                    <div className="name__cat">Исполнитель</div>
                    {ExecutorTask.map(i =>
                        <div key={i.id} className="one__task__cat__block">
                            <div className="one__task__cat__fn">{i.firstName}</div>
                            <div className="one__task__cat__sn">{i.secondName}</div>
                        </div>
                    )}
                    <div className="update__priority__block">
                        <div style={{display: showExecutor ? "none" : "block"}} onClick={() => setShowExecutor(true)}
                             className="up__btn__show">
                            Сменить исполнителя
                        </div>
                        <div style={{display: !showExecutor ? "none" : "flex"}} className="up__pr">
                            <select onChange={e => setExecutor(e.target.value)} value={executor}
                                    className="select__css">
                                <option>Выбор...</option>
                                {allUsers.map(users =>
                                    <option
                                        onClick={() => setExecutor(users)}
                                        key={users.id}
                                        value={users.id}
                                    >
                                        {users.firstName} {users.secondName}
                                    </option>
                                )}
                            </select>
                            <div className="up__btn__show" onClick={() => UpdateExecutorBtn(UpdateExecutor)}>
                                Применить
                            </div>
                            <div className="up__btn__show" onClick={() => setShowExecutor(false)}>
                                Отмена
                            </div>
                        </div>
                    </div>
                    {taskStore.isLoadingPr &&
                        <span className="loader"></span>
                    }
                </div>
            }

            <FilesComponent
                FileTask={FileTask}
                oneTask={oneTask}
            />

            <div className="pinning__task_to_msg_block">

                {oneTask.pinning === false
                    ?
                    <div className="task__pinning__active__block">
                        <div className="task__pinning__active__title">Закрепить задачу:</div>
                        <div className="task__pinning__active__btn" onClick={() => UpdatePinningEnBtn(UpdatePinningEneb)}>
                            <img src={pinning_img} alt={pinning_img}/>
                        </div>
                    </div>
                    :
                    <div className="task__pinning__active__block">
                        <div className="task__pinning__active__title">Открепить задачу:</div>
                        <div className="task__pinning__active__btn task__pinning__no__active__btn"
                             onClick={() => UpdatePinningDisBtn(UpdatePinningDis)}>
                            <img src={pinning_img} alt={pinning_img}/>
                        </div>
                    </div>

                }

                <div className="task_to_msg_block">
                    <div className="task_to_msg_title">Отправить задачу в сообщении:</div>
                    <div
                        className="msg__btn__input"
                        onClick={() => setShowTaskToMsg(true)}
                    >
                        <img src={send} alt={send}/>
                    </div>
                </div>

            </div>

            <div className="tracking__block">
                <div className="tracking__text">Отслеживать задачу</div>
                {TrackingToTask.length
                    ? <div className="tracking__check__yes" onClick={() => TrackingEnAndDis()}></div>
                    : <div className="tracking__check" onClick={() => TrackingEnAndDis()}></div>
                }

            </div>

            <StatementComponent
                StatementTask={StatementTask}
                btnJob={btnJob}
                statementJob={statementJob}
                UserStatement={UserStatement}
                btnYes={btnYes}
                btnNo={btnNo}
                statementYes={statementYes}
                statementNo={statementNo}
                show={show}
                setShow={setShow}
                stText={stText}
                setStText={setStText}
                TaskCloseBtn={TaskCloseBtn}
                TaskClose={TaskClose}
                TaskNew={TaskNew}
                TaskNewBtn={TaskNewBtn}
            />

            <Comments
                oneTask={oneTask}
                allUsers={allUsers}
                show={show}
            />

            <ModalTaskToMessage
                showTaskToMsg={showTaskToMsg}
                setShowTaskToMsg={setShowTaskToMsg}
                allUsers={allUsers}
                setExecutor={setExecutor}
                executor={executor}
                id={id}
            />

        </div>
    );
};

export default observer(Task);